// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmojiCategoryList__container-c9b365 {
  height: 48px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-shrink: 0;
  padding: 0 6px;
  align-items: center;
  justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/EmojiPanel/EmojiCategoryList/EmojiCategoryList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;AACF","sourcesContent":[".container {\n  height: 48px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  padding: 0 6px;\n  align-items: center;\n  justify-content: space-around;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EmojiCategoryList__container-c9b365`
};
module.exports = ___CSS_LOADER_EXPORT___;
